import { __extends } from "tslib";
import { AssetBase, PerspectiveProjection, CoordinateSystem, Transform, Vector3D, } from '@awayjs/core';
import { NodePool } from './ContainerNode';
import { View } from '../View';
import { BasicPartition } from './BasicPartition';
/**
 * @class away.partition.Partition
 */
var PartitionBase = /** @class */ (function (_super) {
    __extends(PartitionBase, _super);
    function PartitionBase(rootNode) {
        var _this = _super.call(this) || this;
        _this._children = new Array();
        _this._updateQueue = {};
        _this.isUpdated = false;
        _this._rootNode = rootNode;
        return _this;
    }
    Object.defineProperty(PartitionBase.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PartitionBase.prototype, "rootNode", {
        get: function () {
            return this._rootNode;
        },
        enumerable: true,
        configurable: true
    });
    PartitionBase.prototype.getLocalView = function (stage) {
        if (!this._localView) {
            /**
            * projection is not simple object
            * not needed spawn it for every cached partition
            * it has 3 matrices = 100 bytes + Transform,
            * that have 4 matrices + a lot of vectors (16 bytes) = 300 bytes,
            * And this is under heavy extending. 1 projection allocate more that 4kb per instance
            */
            var projection = PartitionBase._defaultProjection;
            if (!projection) {
                projection = new PerspectiveProjection();
                projection.coordinateSystem = CoordinateSystem.LEFT_HANDED;
                projection.originX = -1;
                projection.originY = -1;
                projection.transform = new Transform();
                projection.transform.moveTo(0, 0, -1000);
                projection.transform.lookAt(new Vector3D());
            }
            this._localView = new View(projection, stage, null, null, null, true);
            this._localView.backgroundAlpha = 0;
        }
        return this._localView;
    };
    PartitionBase.prototype.clearLocalView = function () {
        if (this._localView)
            this._localView = null;
    };
    PartitionBase.prototype.getLocalNode = function () {
        if (!this._localNode) {
            this._localNode = NodePool.getRootNode(this._rootNode.container, BasicPartition);
            this._localNode.transformDisabled = true;
            this.addChild(this._localNode.partition);
        }
        return this._localNode;
    };
    PartitionBase.prototype.clearLocalNode = function () {
        if (this._localNode) {
            this.removeChild(this._localNode.partition);
            this._localNode.onClear(null);
            this._localNode = null;
        }
    };
    PartitionBase.prototype.addChild = function (child) {
        this._children.push(child);
        child.setParent(this);
        // this.updateNode(child.rootNode);
        if (!this._invalid)
            this.invalidate();
    };
    PartitionBase.prototype.removeChild = function (child) {
        //child.clear();
        this._children.splice(this._children.indexOf(child), 1)[0];
        child.setParent(null);
        // this._rootNode.removeNode(child.rootNode);
        if (!this._invalid)
            this.invalidate();
    };
    PartitionBase.prototype.setParent = function (parent) {
        this._parent = parent;
    };
    PartitionBase.prototype.traverse = function (traverser) {
        this.isUpdated = this._invalid;
        this._invalid = false;
        this._rootNode.acceptTraverser(traverser);
    };
    PartitionBase.prototype.invalidateEntity = function (entityNode) {
        if (!this._invalid)
            this.invalidate();
        this._updateQueue[entityNode.id] = entityNode;
    };
    PartitionBase.prototype.updateEntity = function (entityNode) {
        //TODO: remove reliance on view
        //required for controllers with autoUpdate set to true and queued events
        entityNode.entity._iInternalUpdate();
        this.updateNode(entityNode);
    };
    PartitionBase.prototype.updateNode = function (node) {
        //const targetNode: ContainerNode = this.findParentForNode(node);
        // if (targetNode && node.parent != targetNode) {
        // 	if (node.parent)
        // 		node.parent.removeNode(node);
        // 	targetNode.addNode(node);
        // }
    };
    PartitionBase.prototype.clearEntity = function (entityNode) {
        if (!this._invalid)
            this.invalidate();
        delete this._updateQueue[entityNode.id];
        // const node: INode = entity.getAbstraction<EntityNode>(this);
        // node.parent.removeNode(node);
    };
    /**
     *
     * @param entity
     * @returns {away.partition.NodeBase}
     */
    PartitionBase.prototype.findParentForNode = function (node) {
        return this._rootNode;
    };
    PartitionBase.prototype.updateEntities = function () {
        for (var key in this._updateQueue)
            this.updateEntity(this._updateQueue[key]);
        //clear updateQueue
        this._updateQueue = {};
    };
    PartitionBase.prototype.invalidate = function () {
        this._invalid = true;
        _super.prototype.invalidate.call(this);
        if (this._parent)
            this._parent.invalidate();
    };
    PartitionBase.prototype.clear = function () {
        _super.prototype.clear.call(this);
        this._localView.dispose();
        this._localView = null;
        for (var i = 0; i < this._children.length; i++)
            this._children[i].clear();
    };
    PartitionBase.prototype.dispose = function () {
    };
    // public _setScene(scene: IPartitionEntity): void {
    // 	if (this._scene == scene)
    // 		return;
    // 	this._scene = scene;
    // 	const len: number = this._children.length;
    // 	for (let i: number = 0; i < len; ++i)
    // 		this._children[i]._setScene(scene);
    // }
    PartitionBase.prototype.requestAbstraction = function (asset) {
        return PartitionBase._abstractionClassPool[asset.assetType];
    };
    /**
     *
     * @param imageObjectClass
     */
    PartitionBase.registerAbstraction = function (abstractionClass, assetClass) {
        PartitionBase._abstractionClassPool[assetClass.assetType] = abstractionClass;
    };
    PartitionBase._abstractionClassPool = {};
    return PartitionBase;
}(AssetBase));
export { PartitionBase };
